function stackDelete(key) {
  var data = this.__data__,
      result = data["delete"](key);
  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;
export { _stackDelete as _ };